export const formatPaymentMethod = (method: string | undefined) => {
    console.log("Método de pago recibido:", method); // TEMPORAL: BORRAR DESPUÉS
  
    if (!method) return "Desconocido";
  
    const cleanMethod = method.toLowerCase().trim();
  
    switch (cleanMethod) {
      case "transferencia":
        return "Transferencia";
      case "deposito":
        return "Depósito";
      case "stripe":
        return "Stripe";
      default:
        return "Desconocido";
    }
  };

  export interface IManualPayment {
    moduleId: string;
    title: string;
    week: number;
    paidAt: string;
    amount: number;
    paymentMethod: "transferencia" | "deposito" | "efectivo";
    referenceNumber: string;
  }
  